import React, { Fragment } from 'react';
import Skeleton from 'react-loading-skeleton';

const LoadingOrder = () => {
    return (
        <div className="order">
            <div style={{ display: 'flex', justifyContent: 'space-between', height: 40 }}>
                <Skeleton width="200px" height="30px" />
                <Skeleton width="200px" height="30px" />
            </div>
            <Skeleton width="100" height="100px" />
            <div className="order__content">
                <div className="order__col order__gallery">
                    <Fragment>
                        <Skeleton width="120px" height="120px" style={{ marginRight: 10 }} />
                        <Skeleton width="120px" height="120px" style={{ marginRight: 10 }} />
                        <Skeleton width="120px" height="120px" />
                    </Fragment>
                </div>
                <div className="order__col order__actions">
                    <div style={{ marginLeft: 10, marginBottom: 10 }}>
                        <Skeleton height="40px" count={2} />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default LoadingOrder;
